import { render, staticRenderFns } from "./CompetitionListCollectLayout.vue?vue&type=template&id=17aee793&scoped=true"
import script from "./CompetitionListCollectLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListCollectLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aee793",
  null
  
)

export default component.exports